import { DEVELOPER_API_GET_UNUSED_SUBSCRIPTIONS } from 'apiRoutes';
import SubscriptionTable from 'components/subscription/SubscriptionTable';
import { subscriptionTableColumns } from 'components/subscription/subscriptionTableColumns';
import { FilterSettings } from 'components/tables/Table.interfaces';
import { Subscription } from 'domain/subscription/interfaces/Subscription';
import { useGetOnMount } from 'hooks/useGetOnMount';
import { FunctionComponent, useMemo } from 'react';

const UnusedSubscriptionsTool: FunctionComponent = () => {
	const { data: subscriptions, status } = useGetOnMount<Subscription[]>(
		DEVELOPER_API_GET_UNUSED_SUBSCRIPTIONS,
	);

	const columns = useMemo(() => {
		const columns = [
			subscriptionTableColumns.startDate(),
			subscriptionTableColumns.endDate(),
			subscriptionTableColumns.application(),
			subscriptionTableColumns.plan(),
			subscriptionTableColumns.seats(),
			subscriptionTableColumns.status(),
			subscriptionTableColumns.type(),
			subscriptionTableColumns.company(),
			subscriptionTableColumns.expandedIndicator(),
		];

		return columns;
	}, []);

	const columnFilters: FilterSettings<Subscription> = {
		treatGroupsAsSingle: true,
		groups: [
			{
				columnId: 'companyName',
				filters: [
					{
						text: 'Hide Company Owned',
						value: null,
						selected: true,
					},
					{
						text: 'All',
						value: undefined,
						selected: false,
					},
				],
			},
		],
	};

	return (
		<>
			<SubscriptionTable
				heading="Unused Subscriptions"
				subscriptions={subscriptions}
				columns={columns}
				requestStatus={status}
				filters={columnFilters}
				showRowCount
				//todo: add pagination stuff optional prop
			/>
		</>
	);
};

export default UnusedSubscriptionsTool;
